/**
 * Hair Loss Systems rows (mobile and tablet). Each system section renders one row; this event keeps
 * exactly one open across sections and keeps the intro's concern squares in step.
 */
export const SYSTEM_SELECT_EVENT = "systems:select";

export type SystemSelectDetail = { row: HTMLElement };

export const getSystemRows = (): HTMLElement[] =>
    Array.from(document.querySelectorAll<HTMLElement>("[data-system-row]"));

export const selectSystemRow = (row: HTMLElement): void => {
    document.dispatchEvent(
        new CustomEvent<SystemSelectDetail>(SYSTEM_SELECT_EVENT, {
            detail: { row },
        }),
    );
};

export const selectedRow = (event: Event): HTMLElement | null => {
    const detail = (event as CustomEvent<SystemSelectDetail>).detail;
    return detail?.row instanceof HTMLElement ? detail.row : null;
};
